import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { formatDistanceToNow } from "date-fns";

interface NotificationItemProps {
  notification: any;
  onClick: (notification: any) => void;
}

export const NotificationItem = ({ notification, onClick }: NotificationItemProps) => {
  const getNotificationText = (notification: any) => {
    const actorName = notification.actor?.username || 'Someone';
    switch (notification.type) {
      case 'like':
        return `${actorName} liked your post`;
      case 'follow':
        return `${actorName} started following you`;
      case 'comment':
        return `${actorName} commented on your post`;
      case 'message':
        return `${actorName} sent you a message`;
      default:
        return 'New notification';
    }
  };

  return (
    <DropdownMenuItem
      key={notification.id}
      className="flex items-center gap-4 p-4 cursor-pointer"
      onClick={() => onClick(notification)}
    >
      <Avatar className="h-8 w-8">
        <AvatarImage src={notification.actor?.avatar_url} />
        <AvatarFallback>
          {notification.actor?.username?.[0]?.toUpperCase() || '?'}
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 space-y-1">
        <p className={notification.read_at ? 'text-muted-foreground' : 'font-medium'}>
          {getNotificationText(notification)}
        </p>
        <p className="text-xs text-muted-foreground">
          {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
        </p>
      </div>
    </DropdownMenuItem>
  );
};